exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.hero-image {\n  max-width: 100% !important;\n  min-width: 100%;\n  max-height: 33vh;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n", "", {"version":3,"sources":["/home/runner/work/online-store/online-store/src/components/common/BaseHeroImage.vue"],"names":[],"mappings":";AAAA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,qBAAkB;KAAlB,kBAAkB;CAAE","file":"BaseHeroImage.vue","sourcesContent":[".hero-image {\n  max-width: 100% !important;\n  min-width: 100%;\n  max-height: 33vh;\n  object-fit: cover; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6f751b08","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/BaseHeroImage.vue
// module id = Bu78
// module chunks = 18